/* ============================================
   DRINK NIU — THEME JS
   Form handlers + Scroll reveals + Tea selector
   ============================================ */

// ── Utility ──────────────────────────────────
function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function showError(el) {
  el.style.borderColor = '#9a3a28';
  el.focus();
  setTimeout(() => { el.style.borderColor = ''; }, 2000);
}

function showSuccess(formAreaId, successId) {
  const formArea = document.getElementById(formAreaId);
  const success  = document.getElementById(successId);
  if (formArea) formArea.style.display = 'none';
  if (success)  { success.classList.add('show'); success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
}

// Klaviyo stub — swap YOUR_LIST_ID when ready
function subscribeToKlaviyo(data) {
  // Replace the console.log below with your Klaviyo /client/subscriptions/ call
  console.log('[Drink Niu] Waitlist signup:', data);
  // fetch('https://a.klaviyo.com/client/subscriptions/?company_id=YOUR_COMPANY_ID', {
  //   method: 'POST',
  //   headers: { 'content-type': 'application/json', 'revision': '2023-02-22' },
  //   body: JSON.stringify({
  //     data: {
  //       type: 'subscription',
  //       attributes: {
  //         list_id: 'YOUR_LIST_ID',
  //         email: data.email,
  //         properties: { first_name: data.name, tea_preference: data.tea }
  //       }
  //     }
  //   })
  // });
}

// ── Hero form ────────────────────────────────
window.handleHeroSubmit = function () {
  const nameEl  = document.getElementById('hero-fname');
  const emailEl = document.getElementById('hero-email');
  if (!nameEl || !emailEl) return;

  if (!nameEl.value.trim())            { showError(nameEl);  return; }
  if (!validateEmail(emailEl.value))   { showError(emailEl); return; }

  subscribeToKlaviyo({ name: nameEl.value.trim(), email: emailEl.value.trim(), source: 'hero' });
  showSuccess('hero-form-area', 'hero-success');
};

// ── Brewer notify form ────────────────────────
window.handleBrewerSubmit = function () {
  const emailEl = document.getElementById('brewer-email');
  if (!emailEl) return;
  if (!validateEmail(emailEl.value)) { showError(emailEl); return; }

  subscribeToKlaviyo({ email: emailEl.value.trim(), source: 'brewer', interest: 'bru_er_preorder' });
  showSuccess('brewer-form-area', 'brewer-success');
};

// ── Waitlist form ─────────────────────────────
window.handleWaitlistSubmit = function () {
  const nameEl  = document.getElementById('wl-fname');
  const emailEl = document.getElementById('wl-email');
  if (!nameEl || !emailEl) return;

  if (!nameEl.value.trim())            { showError(nameEl);  return; }
  if (!validateEmail(emailEl.value))   { showError(emailEl); return; }

  const activeTea = document.querySelector('.tea-sel-btn.active');
  const tea = activeTea ? activeTea.dataset.tea : '';

  subscribeToKlaviyo({ name: nameEl.value.trim(), email: emailEl.value.trim(), tea, source: 'waitlist' });
  showSuccess('waitlist-form-area', 'waitlist-success');
};

// ── Enter key support ─────────────────────────
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;
  const active = document.activeElement;
  if (!active) return;

  if (active.id === 'hero-fname' || active.id === 'hero-email')    { handleHeroSubmit();     return; }
  if (active.id === 'brewer-email')                                 { handleBrewerSubmit();   return; }
  if (active.id === 'wl-fname' || active.id === 'wl-email')        { handleWaitlistSubmit(); return; }
});

// ── Tea selector ──────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  const btns = document.querySelectorAll('.tea-sel-btn');
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      btns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ── Scroll reveal ──────────────────────────
  const targets = document.querySelectorAll(
    '.science-card, .disc, .sub-tier, .brewer-section, .founder-inner, ' +
    '.manifesto-section, .tea-high-bar, .sub-includes, .sourced-pillars'
  );

  targets.forEach(el => el.classList.add('reveal-on-scroll'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  targets.forEach(el => observer.observe(el));
});
